export const getters = {
  appTitle (state) {
    return state.appTitle
  },
  isAuthenticated (state) {
    return state.isAuthenticated === 'true'
  },
  getUser (state) {
    return state.user
    // return JSON.parse(localStorage.getItem("user"))
  },
  getError (state) {
    return state.error
  },
  getLoading (state) {
    return state.loading
  },
  getUsers (state) {
    return state.users
  },
  getPerPage (state) {
    return state.perPage;
  },
  getTransfers(state){
    return state.transfers;
  }
}
